import { Button, Text } from '@chakra-ui/react';
import { MaterialIcon } from '../../../ui/MaterialIcon';
import type { CreateDestination } from '../destination/createDestination';

interface InsideChipProps {
  readonly parent: CreateDestination;
  readonly onChange: () => void;
  readonly isDisabled?: boolean;
}

/**
 * "Inside {parent}": where a new collection will sit. Opens the same picker
 * as every other destination choice in the modal, so there is one way to pick
 * a place.
 */
export function InsideChip({ parent, onChange, isDisabled }: InsideChipProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      borderRadius="full"
      alignSelf="flex-start"
      maxW="full"
      isDisabled={isDisabled}
      onClick={onChange}
      aria-label={`Inside ${parent.name}. Change where it goes`}
      leftIcon={
        <MaterialIcon
          name={parent.type === 'workspace' ? 'home' : 'folder'}
          boxSize={4}
          color="text.secondary"
        />
      }
      rightIcon={<MaterialIcon name="expand_more" boxSize={4} color="text.secondary" />}
    >
      <Text as="span" color="text.secondary" mr={1}>
        Inside
      </Text>
      <Text as="span" color="text.primary" noOfLines={1}>
        {parent.name}
      </Text>
    </Button>
  );
}
